module.exports = __webpack_public_path__ + "static/media/instructivoac4.3b06767d.png";